import DisclosureInfo from "./DisclosureInfo";
export default DisclosureInfo;
